import { InvoiceFormValues } from 'app/components/InvoiceForm/schema'
import formatDateForApi from 'helpers/formatDateForApi'
import { Invoice } from 'types'

const computeDiffLines = (invoice: Invoice, data: InvoiceFormValues) => {
  const newLines = data.invoice_lines.filter(
    (line) =>
      !invoice.invoice_lines.find((l) => Number(l.id) === Number(line.id))
  )
  const deletedLines = invoice.invoice_lines.filter(
    (line) => !data.invoice_lines.find((l) => Number(l.id) === Number(line.id))
  )
  const updatedLines = data.invoice_lines.filter((line) =>
    invoice.invoice_lines.find((l) => Number(l.id) === Number(line.id))
  )

  return {
    newLines,
    deletedLines,
    updatedLines,
  }
}

const transformValuesToApi = (invoice: Invoice, data: InvoiceFormValues) => {
  const { newLines, deletedLines, updatedLines } = computeDiffLines(
    invoice,
    data
  )

  return {
    invoice: {
      id: Number(invoice.id),
      customer_id: Number(data.customer?.id),
      date: formatDateForApi(data.issueDate),
      deadline: formatDateForApi(data.deadline),
      paid: data.paid,
      finalized: data.finalized,
      invoice_lines_attributes: [
        ...newLines.map((line) => ({
          product_id: Number(line.product?.id),
          quantity: line.quantity,
        })),
        ...deletedLines.map((line) => ({
          id: line.id,
          _destroy: true,
        })),
        ...updatedLines.map((line) => ({
          id: line.id,
          product_id: Number(line.product?.id),
          quantity: line.quantity,
        })),
      ],
    },
  }
}

export default transformValuesToApi
